import { render } from "./ProductSectionProductComponent.vue?vue&type=template&id=ba27f074"
import script from "./ProductSectionProductComponent.vue?vue&type=script&lang=js"
export * from "./ProductSectionProductComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/product/ProductSectionProductComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ba27f074"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ba27f074', __exports__)) {
    api.reload('ba27f074', __exports__)
  }
  
  module.hot.accept("./ProductSectionProductComponent.vue?vue&type=template&id=ba27f074", () => {
    api.rerender('ba27f074', render)
  })

}


export default __exports__